var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Banner'),_c('WhatCloudEnterprise'),_c('ProjectOperation'),_c('WhyCloudEnterprise'),_c('PainPointScenario'),_c('Contradiction'),_c('CoreCompetencies'),_c('SolveProblem'),_c('ConcernProblem'),_c('CloudEnterpriseAuth')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }